export const fields = [
  {
    name: "Fullname",
    key: "fullName",
    type: "text",
    placeholder: "Enter Name",
    validation: "required",
  },
  {
    name: "Email Address",
    key: "email",
    type: "email",
    placeholder: "Enter Email Address",
    validation: "required",
  },
  {
    name: "Role",
    key: "role",
    type: "select",
    options: [
      "admin",
      "supervisor",
      "route_manager",
      "area_manager",
      "function_manager",
    ],
    placeholder: "Select Role",
    validation: "required",
  },

  // New RBAC-specific fields
  {
    name: "Function",
    key: "function",
    type: "select",
    options: [
      "wales_and_western_region",
      "eastern_region",
      "southern_region",
    ],
  },
  {
    name: "Route",
    key: "route",
    type: "select",
    options: ["wales", "western"],
  },
  {
    name: "Area",
    key: "area",
    type: "select",
    options: ["operations_delivery", "safety", "planning"],
  },

  {
    name: "Send Welcome Email",
    key: "sendWelcomeEmail",
    type: "checkbox",
  },
  {
    name: "Require Training",
    key: "requireTraining",
    type: "checkbox",
  },
];
